import { useState } from "react";
import { Navbar, NavbarToggler, Collapse, Nav, 
  NavItem, DropdownMenu, UncontrolledDropdown, 
  DropdownToggle } from "reactstrap";
import { Link, NavLink, useNavigate } from 'react-router-dom';

import classes from './Header.module.scss';

import logo_conia from "../../assets/img/FiaLinks_logo_black.svg"

import { useUserContext } from "../../contexts/UserContext";
import { useConfigContext } from '../../contexts/ConfigContext';
import { useTranslation } from "react-i18next";

import { MdMenu, MdDashboard, MdEdit, MdExitToApp, MdTranslate } from 'react-icons/md';

const Header = ({ pages=[], concatPath="", isLogin=false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { token, logout } = useUserContext();
  const { startLoading, stopLoading, setLang, lang, scrollY } = useConfigContext();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onLogout = (e) => {
    e.preventDefault();
    startLoading("logging-out");
    logout();
    navigate("/")
    stopLoading("logging-out");
  }

  const linkGeneration = (pagesToMap) => {
    return pagesToMap.map((page) => {
      if(page.loginReq && !token) {
        return;
      }

      if(page.hidden) {
        return;
      }

      if(page.pages) {
        return (
          <UncontrolledDropdown key={`nav-${page.id}`} inNavbar nav>
            <DropdownToggle className="text-black" caret nav> {page.icon} {page.title} </DropdownToggle>
            <DropdownMenu tag="ul"
              className="px-4 !bg-conia-light border-0 rounded-sm" end>
                {linkGeneration(page.pages)}
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      }else {
        return (
          <NavItem key={`nav-${page.id}`} onClick={() => { setIsOpen(false) }}>
            <NavLink to={concatPath + page.url}
              className={({ isActive })=> {

                let name = "nav-link text-black"
                name = page.disabled ? `${name} ${classes.disabled}` : name;
                name = isActive ? `${name} ${classes.active}` : name;

                return name;
              }}> 
                {page.icon}
                {page.title} 
            </NavLink>
          </NavItem>
        );
      }
    })
  }

  return (
    <Navbar expand="lg" color="light" data-scroll = { scrollY } 
      className={`${ classes.header } !sticky left-0 top-0 drop-shadow-sm !shadow-conia-light z-50`}>
      <h1 className="visually-hidden">FIA Links 2022</h1>

      <div className={`container-fluid ${ classes.container }`}>
        <Link to="/" className={`${ classes.brand }`}> 
          <img id={`${ classes.logo }`} src={logo_conia} alt="FIA Links 2022"/>
        </Link>

        <NavbarToggler onLoad={(e) => { console.log(e.target) }} onClick={()=> { setIsOpen(!isOpen) }}>
            <MdMenu/>
        </NavbarToggler>

        <Collapse isOpen={isOpen} navbar>
          <Nav className={`${classes.links} flex-1`} navbar>
            {
              linkGeneration(pages)
            }
          </Nav>
          <Nav className={classes["links"]} navbar>
            <NavItem onClick={() => { setIsOpen(false) }}>
              <button onClick={() => setLang(lang === "es" ? "en" : "es")} className="nav-link cursor-pointer text-black">
                <MdTranslate/>
                { lang === "es" ? "English" : "Español" }
              </button>
            </NavItem>
          </Nav>
          {
            isLogin ||
            <Nav className={classes["links"]} navbar>
            <NavItem onClick={() => { setIsOpen(false) }}>
              <Link className="nav-link text-black" to={token ? "/app" : "/auth/signin"}>
                { token ? <MdDashboard/> : <MdEdit/> }
                { token ? t("header_dashboard_text") : t("header_signin_text") }
              </Link>
            </NavItem>
            {token &&
              <NavItem onClick={() => { setIsOpen(false) }}>
                <button onClick={onLogout} className="nav-link cursor-pointer text-black">
                  <MdExitToApp/>
                  { t("header_signout_text") }
                </button>
              </NavItem>
            }
          </Nav>
          }
        </Collapse>
      </div>
    </Navbar>
  );
}

export default Header;